// extracted by mini-css-extract-plugin
module.exports = {"Actions":"action-bar_Actions__2mCgf","Fixed":"action-bar_Fixed__fTJFE"};